import type { ReactNode } from "react";

import styles from "./Panel.module.css";

interface PanelProps {
  title: string;
  /** Short line under the title. Says what the panel is for, not what it is called. */
  hint?: string;
  aside?: ReactNode;
  children: ReactNode;
  /** Removes the inner padding for panels that hold a full-bleed drawing. */
  flush?: boolean;
}

export function Panel({ title, hint, aside, children, flush = false }: PanelProps) {
  return (
    <section className={styles.panel}>
      <header className={styles.head}>
        <div>
          {/* The mesh marker before a section title (design 2026-10-24 §8.6). */}
          <h2 className={styles.title}>
            <span className="marke" aria-hidden="true" />
            {title}
          </h2>
          {hint ? <p className={styles.hint}>{hint}</p> : null}
        </div>
        {aside ? <div className={styles.aside}>{aside}</div> : null}
      </header>
      <div className={flush ? styles.bodyFlush : styles.body}>{children}</div>
    </section>
  );
}
